/* WearCavero bundle selector (PDP) + cart upsell (slider), ported from BellvaroWear Oct 8 / Oct 10. No third-party code.
   Discounts themselves are Shopify automatic discounts; this file never changes prices. */
(function () {
  'use strict';
  var money = function (c) {
    try { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); }
    catch (e) { return '\u00a3' + (c / 100).toFixed(2); }
  };
  var addUrl = function () { return (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js'; };

  /* ---------------- Bundle selector + per-item rows ---------------- */
  function initBundle(root) {
    if (root.__bndl) return; root.__bndl = true;
    var form = document.getElementById(root.dataset.formId);
    var data;
    try { data = JSON.parse(root.querySelector('[data-bndl-product]').textContent); } catch (e) { return; }
    var variants = data.variants || [], optNames = data.options || [], imgs = data.images || {};
    var byId = function (id) { id = Number(id); for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return null; };
    var qtyInput = root.querySelector('[data-bndl-qty]');
    var opts = Array.prototype.slice.call(root.querySelectorAll('.bndl__opt'));
    var rowsWrap = root.querySelector('[data-bndl-rows]');
    var qty = parseInt(qtyInput.value, 10) || 1;
    var sticky = null;

    // option values in first-seen order; only options with >1 value get a select
    var valuesByOpt = optNames.map(function (_, k) {
      var seen = []; variants.forEach(function (v) { var x = v.options[k]; if (seen.indexOf(x) < 0) seen.push(x); }); return seen;
    });
    var multi = []; valuesByOpt.forEach(function (vals, k) { if (vals.length > 1) multi.push(k); });

    var masterId = function () { var s = form && form.querySelector('[name="id"]'); return s ? s.value : null; };
    var firstAvail = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var current = byId(masterId()) || firstAvail;
    var items = [current.id, current.id, current.id], touched = [false, false, false];

    var matches = function (v, vals, upto) { for (var i = 0; i < multi.length; i++) { var j = multi[i]; if (upto != null && j > upto) continue; if (v.options[j] !== vals[j]) return false; } return true; };
    var findAvail = function (vals, upto) { for (var i = 0; i < variants.length; i++) if (variants[i].available && matches(variants[i], vals, upto)) return variants[i]; return null; };
    var findExact = function (vals) { for (var i = 0; i < variants.length; i++) if (matches(variants[i], vals, null)) return variants[i]; return null; };

    /* build rows */
    var rows = [];
    if (rowsWrap && multi.length) {
      Array.prototype.forEach.call(rowsWrap.querySelectorAll('[data-bndl-ph]'), function (ph) { ph.parentNode.removeChild(ph); });
      for (var n = 0; n < 3; n++) {
        var row = document.createElement('div'); row.className = 'bndl__row'; row.dataset.row = String(n + 1);
        var th = document.createElement('img'); th.className = 'bndl__thumb'; th.alt = ''; th.width = 44; th.height = 44; th.loading = 'lazy'; row.appendChild(th);
        var sels = [];
        multi.forEach(function (k) {
          var s = document.createElement('select');
          var nm = String(optNames[k] || '');
          s.className = 'bndl__sel' + (/colou?r|kleur|farbe|couleur/i.test(nm) ? '' : ' bndl__sel--size');
          s.setAttribute('aria-label', 'Item ' + (n + 1) + ' ' + nm.toLowerCase());
          s.dataset.k = String(k);
          (function (rowIdx, optIdx) { s.addEventListener('change', function () { onRowChange(rowIdx, optIdx, this.value); }); })(n, k);
          row.appendChild(s); sels.push(s);
        });
        rowsWrap.appendChild(row); rows.push({ el: row, sels: sels, th: th });
      }
    }
    function refreshRow(n) {
      var r = rows[n]; if (!r) return;
      var vals = byId(items[n]).options;
      var src = imgs[items[n]] || imgs[current.id];
      if (r.th) { if (src) { if (r.th.getAttribute('src') !== src) r.th.src = src; r.th.hidden = false; } else r.th.hidden = true; }
      r.sels.forEach(function (s) {
        var k = Number(s.dataset.k);
        var html = valuesByOpt[k].map(function (val) {
          var ok = variants.some(function (x) {
            if (!x.available || x.options[k] !== val) return false;
            for (var i = 0; i < multi.length; i++) { var j = multi[i]; if (j < k && x.options[j] !== vals[j]) return false; }
            return true;
          });
          return '<option value="' + escapeHtml(val) + '"' + (ok ? '' : ' disabled') + '>' + escapeHtml(val) + (ok || /sold out|out of stock/i.test(val) ? '' : ' (sold out)') + '</option>';
        }).join('');
        if (s.__html !== html) { s.innerHTML = html; s.__html = html; }
        s.value = vals[k];
      });
    }
    function onRowChange(n, k, val) {
      var vals = byId(items[n]).options.slice(); vals[k] = val;
      var v = findExact(vals);
      if (!v || !v.available) v = findAvail(vals, k) || v;
      if (!v) return;
      items[n] = v.id; touched[n] = true;
      if (sticky) sticky.chosen = true;
      if (n === 0) syncMain(v);
      render();
    }
    function syncMain(v) {
      var sec = (form && form.closest('[data-section-type="product"]')) || document;
      v.options.forEach(function (val, i) {
        // Swatch King UI (visible picker) first, so its selected state, the gallery and the variant all move together
        var sk = sec.querySelectorAll('.swatch-selector[swatch-option="option' + (i + 1) + '"]');
        for (var y = 0; y < sk.length; y++) if (sk[y].getAttribute('orig-value') === val) { if (!sk[y].classList.contains('swatch-selected')) sk[y].click(); return; }
        var inputs = sec.querySelectorAll('input[data-variant-input][data-index="option' + (i + 1) + '"]');
        for (var x = 0; x < inputs.length; x++) if (inputs[x].value === val) { if (!inputs[x].checked) inputs[x].click(); break; }
      });
    }

    /* per-item rows live inside the selected card; slots animate open/closed */
    var reduceMotion = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
    function clearSlot(sl) {
      if (sl.__t) { clearTimeout(sl.__t); sl.__t = null; }
      if (sl.__ghost) { if (sl.__ghost.parentNode) sl.__ghost.parentNode.removeChild(sl.__ghost); sl.__ghost = null; }
    }
    function collapse(sl, ghost) {
      clearSlot(sl);
      var h = sl.offsetHeight;
      if (ghost && !reduceMotion()) {
        var g = rowsWrap.cloneNode(true), src = rowsWrap.querySelectorAll('select'), dst = g.querySelectorAll('select');
        for (var i = 0; i < dst.length; i++) { dst[i].selectedIndex = src[i].selectedIndex; dst[i].disabled = true; dst[i].tabIndex = -1; }
        g.removeAttribute('data-bndl-rows'); g.setAttribute('aria-hidden', 'true');
        sl.querySelector('.bndl__slot-in').appendChild(g); sl.__ghost = g;
      }
      sl.classList.remove('is-open');
      if (reduceMotion()) { sl.style.height = ''; return; }
      sl.style.height = h + 'px'; void sl.offsetHeight; sl.style.height = '0px';
      sl.__t = setTimeout(function () { clearSlot(sl); sl.style.height = ''; }, 340);
    }
    function expand(sl) {
      clearSlot(sl);
      sl.classList.add('is-open');
      if (reduceMotion()) { sl.style.height = ''; return; }
      var h = sl.querySelector('.bndl__slot-in').offsetHeight;
      sl.style.height = '0px'; void sl.offsetHeight; sl.style.height = h + 'px';
      sl.__t = setTimeout(function () { sl.__t = null; sl.style.height = ''; }, 340);
    }
    function placeRows() {
      if (!rowsWrap || !rows.length) return;
      var selCard = root.querySelector('.bndl__opt.is-selected');
      var target = qty >= 2 && selCard ? selCard.querySelector('[data-bndl-slot]') : null;
      var cur = rowsWrap.closest('[data-bndl-slot]');
      Array.prototype.forEach.call(root.querySelectorAll('[data-bndl-slot]'), function (sl) {
        if (sl !== target && sl.classList.contains('is-open')) collapse(sl, sl === cur && !!target);
      });
      if (target) {
        if (cur !== target) target.querySelector('.bndl__slot-in').appendChild(rowsWrap);
        if (!target.classList.contains('is-open')) expand(target);
      }
    }

    function lineVariants(q) {
      if (q < 2 || !rows.length) { var a = []; for (var i = 0; i < q; i++) a.push(current); return a; }
      return items.slice(0, q).map(byId);
    }
    function render() {
      opts.forEach(function (o) {
        var q = Number(o.dataset.qty), pct = Number(o.dataset.pct), vs = lineVariants(q);
        var sub = 0, cmp = 0;
        vs.forEach(function (v) { sub += v.price; cmp += (v.compare_at_price > v.price ? v.compare_at_price : v.price); });
        var total = sub - Math.floor(sub * pct / 100 + 1e-9); // Shopify rounds the order discount down (e.g. 15% of £79.90 = £11.98)
        var extra = sub - total, saving = cmp - total;
        o.querySelector('[data-bndl-total]').textContent = money(total);
        var set = function (sel, val) { var el = o.querySelector(sel); if (el) el.textContent = val; return el; };
        set('[data-bndl-each]', money(Math.round(total / q)));
        var c = o.querySelector('[data-bndl-cmp]');
        if (c) { if (cmp > total) { c.hidden = false; c.textContent = money(cmp); } else { c.hidden = true; c.textContent = ''; } }
        var box = o.querySelector('[data-bndl-savebox]');
        if (box) box.hidden = extra <= 0;
        var on = q === qty;
        o.classList.toggle('is-selected', on);
        o.querySelector('input').checked = on;
      });
      qtyInput.value = qty;
      rows.forEach(function (r, n) { r.el.hidden = n >= qty; if (n < qty) refreshRow(n); });
      placeRows();
      if (sticky) sticky.sync();
    }

    opts.forEach(function (o) {
      o.querySelector('input').addEventListener('change', function () { qty = Number(o.dataset.qty); render(); });
    });

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant; if (!v) return;
      var nv = byId(v.id); if (!nv) return;
      current = nv;
      if (sticky) sticky.chosen = true;
      items[0] = nv.id;
      for (var i = 1; i < 3; i++) if (!touched[i]) items[i] = nv.id;
      render();
    });

    /* Buy 2/3: one line per item in a single /cart/add.js call, then the theme opens the drawer as usual. */
    document.addEventListener('submit', function (e) {
      if (!form || e.target !== form || qty < 2 || !rows.length) return; // Buy 1 / single-variant: theme's own path
      e.preventDefault(); e.stopPropagation();
      var btn = form.querySelector('[data-add-to-cart]');
      var vs = lineVariants(qty), order = [], agg = {};
      for (var i = 0; i < vs.length; i++) {
        if (!vs[i] || !vs[i].available) { showErr('Item ' + (i + 1) + ' is sold out. Please choose another option.'); return; }
        if (!agg[vs[i].id]) { agg[vs[i].id] = 0; order.push(vs[i].id); }
        agg[vs[i].id]++;
      }
      var payload = { items: order.map(function (id) { return { id: id, quantity: agg[id] }; }) };
      if (btn) btn.classList.add('btn--loading');
      fetch(addUrl(), { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (btn) btn.classList.remove('btn--loading');
          if (d && d.status && d.status !== 200) { showErr(d.description || d.message || 'Could not add to cart'); document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: d.description } })); return; }
          var old = form.querySelector('.errors'); if (old) old.remove();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: d, addToCartBtn: btn } }));
        })
        .catch(function () { if (btn) btn.classList.remove('btn--loading'); document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: {} })); });
    }, true);
    function showErr(msg) {
      var old = form.querySelector('.errors'); if (old) old.remove();
      var div = document.createElement('div'); div.className = 'errors text-center'; div.textContent = msg; form.appendChild(div);
    }

    sticky = initSticky(root, form, function () { return qty; });
    render();
  }

  /* ---------------- Sticky mobile add-to-cart ---------------- */
  function initSticky(root, form, getQty) {
    var bar = root.querySelector('[data-aov-sticky]');
    var mainBtn = form && form.querySelector('[data-add-to-cart]');
    if (!bar || !mainBtn || !window.IntersectionObserver) return null;
    document.body.appendChild(bar); // escape any transformed ancestor so position:fixed is viewport-relative
    var mq = window.matchMedia('(max-width: 768px)');
    var btn = bar.querySelector('[data-st-btn]');
    var label = bar.querySelector('[data-st-label]'), totalEl = bar.querySelector('[data-st-total]'), cmpEl = bar.querySelector('[data-st-save]');
    var footer = document.querySelector('.site-footer, footer');
    var atcVisible = true, footerVisible = false, loading = false;
    var api = { chosen: bar.dataset.needsChoice !== 'true' || /[?&]variant=/.test(location.search) };

    api.sync = function () {
      var sel = root.querySelector('.bndl__opt.is-selected') || root.querySelector('.bndl__opt');
      if (sel) {
        var lb = sel.querySelector('[data-bndl-label]'); label.textContent = lb ? lb.textContent.trim() : String(getQty());
        totalEl.textContent = sel.querySelector('[data-bndl-total]').textContent;
        var sb = sel.querySelector('[data-bndl-savebox]');
        cmpEl.textContent = sb && !sb.hidden ? sb.textContent.replace(/\s+/g, ' ').trim() : '';
      }
      var txt = mainBtn.querySelector('[data-add-to-cart-text]');
      if (!loading) btn.textContent = (txt ? txt.textContent : mainBtn.textContent).trim();
      btn.disabled = mainBtn.disabled;
    };
    function blocked() {
      var h = document.documentElement, b = document.body;
      if (h.classList.contains('js-drawer-open') || b.classList.contains('js-drawer-open')) return true;
      if (b.classList.contains('modal-open') || h.classList.contains('modal-open') || document.querySelector('.pswp--open')) return true;
      var cb = document.getElementById('shopify-pc__banner');
      if (cb && cb.offsetHeight > 0 && getComputedStyle(cb).display !== 'none' && getComputedStyle(cb).visibility !== 'hidden') return true;
      return false;
    }
    function update() {
      var show = mq.matches && !atcVisible && !footerVisible && !blocked();
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('aov-sticky-on', show);
    }
    new IntersectionObserver(function (es) { atcVisible = es[0].isIntersecting; update(); }).observe(mainBtn);
    if (footer) new IntersectionObserver(function (es) { footerVisible = es[0].isIntersecting; update(); }).observe(footer);
    var mo = new MutationObserver(update);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
    new MutationObserver(api.sync).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    if (mq.addEventListener) mq.addEventListener('change', update);

    function done() { loading = false; btn.classList.remove('btn--loading'); api.sync(); }
    document.addEventListener('ajaxProduct:added', done);
    document.addEventListener('ajaxProduct:error', done);

    btn.addEventListener('click', function () {
      if (btn.disabled || loading) return;
      if (!api.chosen) { pointToPicker(form); return; }
      loading = true; btn.classList.add('btn--loading');
      setTimeout(function () { if (loading) done(); }, 8000);
      if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });
    api.sync(); update();
    return api;
  }
  function pointToPicker(form) {
    var section = form.closest('[data-section-type="product"]') || document;
    var re = /^(size|maat|gr(ö|o)(ss|ß)e)\b/i, anchor = null;
    // visible size label (Swatch King UI or theme label)
    var cands = section.querySelectorAll('.product-single__meta label, .product-single__meta legend, .product-single__meta span, .product-single__meta div, .product-single__meta p');
    for (var i = 0; i < cands.length && !anchor; i++) {
      var el = cands[i];
      if (el.children.length > 1 || !el.offsetParent) continue;
      if (re.test((el.textContent || '').trim()) && (el.textContent || '').trim().length < 24) anchor = el;
    }
    if (anchor) anchor = anchor.closest('.swatch-single, .variant-wrapper, .product-block') || anchor;
    if (!anchor) { var w = section.querySelector('.variant-wrapper'); anchor = w && w.closest('.product-block'); }
    if (!anchor) return;
    var old = document.querySelector('.aov-pick-hint'); if (old) old.remove();
    var hint = document.createElement('span'); hint.className = 'aov-pick-hint'; hint.setAttribute('role', 'status'); hint.textContent = 'Please choose your size';
    anchor.parentNode.insertBefore(hint, anchor);
    var y = hint.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    requestAnimationFrame(function () { hint.classList.add('is-on'); });
    setTimeout(function () { hint.classList.remove('is-on'); setTimeout(function () { hint.remove(); }, 250); }, 3500);
  }

  /* ---------------- Cart upsell ---------------- */
  var recCache = {};
  function getRecs(pid) {
    if (recCache[pid]) return recCache[pid];
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var get = function (intent) {
      return fetch(base + 'recommendations/products.json?limit=8&product_id=' + pid + '&intent=' + intent, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return { intent: intent, products: (d && d.products) || [] }; })
        .catch(function () { return { intent: intent, products: [] }; });
    };
    recCache[pid] = get('complementary').then(function (res) {
      return res.products.length ? res : get('related');
    });
    return recCache[pid];
  }
  function srcOf(x) { return !x ? '' : typeof x === 'string' ? x : (x.src || (x.preview_image && x.preview_image.src) || ''); }
  function sized(u) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  /* variant image -> first product image whose alt/filename matches the colour -> product image */
  function upImg(p, v) {
    var u = v && srcOf(v.featured_image);
    if (!u && v) {
      var cIdx = -1;
      optionNames(p).forEach(function (n, i) { if (/colou?r|kleur|farbe|couleur/i.test(n)) cIdx = i; });
      var c = cIdx > -1 ? String(v['option' + (cIdx + 1)] || '').toLowerCase().trim() : '';
      if (c) {
        var norm = function (t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };
        var cn = norm(c), re = new RegExp('(^| )' + cn.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '( |$)');
        var media = (p.media || []).map(function (m) { return { alt: m.alt, src: srcOf(m) }; });
        var imgs = media.length ? media : (p.images || []).map(function (i) { return { alt: i && i.alt, src: srcOf(i) }; });
        imgs.some(function (m) { if (re.test(norm(m.alt))) { u = m.src; return true; } return false; }) ||
        imgs.some(function (m) { var fn = (m.src || '').split('?')[0].split('/').pop(); if (re.test(norm(fn))) { u = m.src; return true; } return false; });
      }
    }
    if (!u) u = srcOf(p.featured_image) || srcOf(p.images && p.images[0]);
    return sized(u);
  }
  function optionNames(p) { return (p.options || []).map(function (o) { return (typeof o === 'string' ? o : o.name) || ''; }); }

  function fillUpsell(box) {
    if (box.__done) return; box.__done = true;
    var pid = box.dataset.productId; if (!pid) return;
    var inCart = (box.dataset.cartProducts || '').split(',');
    var wantSize = (box.dataset.size || '').toLowerCase();
    var count = Math.max(1, Math.min(4, parseInt(box.dataset.count, 10) || 1));
    var showOpts = box.dataset.showOptions !== 'false';
    var btnText = box.dataset.button || 'Add';
    var heading = box.dataset.heading || 'You may also like';
    var source;
    if (box.dataset.mode === 'manual') {
      var list = [];
      try { var el = box.querySelector('[data-aov-upsell-products]'); list = el ? JSON.parse(el.textContent) : []; } catch (e) { list = []; }
      source = Promise.resolve({ intent: 'manual', products: list });
    } else {
      source = getRecs(pid);
    }
    source.then(function (res) {
      var ps = (res.products || []).filter(function (x) { return x && x.available && inCart.indexOf(String(x.id)) < 0; }).slice(0, count);
      if (!ps.length) { box.hidden = true; return; }
      // default heading keeps the original wording for complementary results
      var title = (res.intent === 'complementary' && heading === 'You may also like') ? 'Complete the look' : heading;
      if (box.dataset.layout === 'list' || ps.length < 2) {
        box.innerHTML = '<p class="aov-up__title">' + escapeHtml(title) + '</p>';
        ps.forEach(function (p) { box.appendChild(upCard(p, wantSize, showOpts, btnText)); });
        box.hidden = false;
        return;
      }
      buildUpSlider(box, title, ps.map(function (p) { return upCard(p, wantSize, showOpts, btnText); }));
    });
  }
  /* slider layout (setting cart_upsell_layout): scroll-snap track + arrows + dots */
  function buildUpSlider(box, title, cards) {
    var chev = function (d) { return '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="' + (d < 0 ? 'M7.5 2 3.5 6l4 4' : 'M4.5 2l4 4-4 4') + '" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>'; };
    box.classList.add('aov-up--slider');
    box.innerHTML = '<div class="aov-up__head"><p class="aov-up__title">' + escapeHtml(title) + '</p>' +
      '<div class="aov-up__nav"><button type="button" class="aov-up__arrow" data-up-prev aria-label="Previous product">' + chev(-1) + '</button>' +
      '<button type="button" class="aov-up__arrow" data-up-next aria-label="Next product">' + chev(1) + '</button></div></div>' +
      '<div class="aov-up__track" role="region" aria-label="' + escapeHtml(title) + '"></div><div class="aov-up__dots"></div>';
    var track = box.querySelector('.aov-up__track'), dots = box.querySelector('.aov-up__dots');
    var prev = box.querySelector('[data-up-prev]'), next = box.querySelector('[data-up-next]');
    cards.forEach(function (c, i) {
      c.setAttribute('aria-label', (i + 1) + ' of ' + cards.length); track.appendChild(c);
      var d = document.createElement('button'); d.type = 'button'; d.className = 'aov-up__dot'; d.setAttribute('aria-label', 'Show product ' + (i + 1));
      d.addEventListener('click', function () { go(i); }); dots.appendChild(d);
    });
    var idx = function () {
      var x = track.scrollLeft, best = 0, bd = Infinity;
      cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - track.offsetLeft - x); if (dd < bd) { bd = dd; best = i; } });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = cards.length - 1;
      return best;
    };
    var go = function (i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    var sync = function () {
      var i = idx();
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      prev.disabled = i === 0; next.disabled = i === cards.length - 1;
    };
    prev.addEventListener('click', function () { go(idx() - 1); });
    next.addEventListener('click', function () { go(idx() + 1); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    box.hidden = false;
    sync();
  }
  function upCard(p, wantSize, showOpts, btnText) {
    var names = optionNames(p), sIdx = -1;
    names.forEach(function (n, i) { if (/size|maat|gr(ö|o)(ss|ß)e/i.test(n)) sIdx = i; });
    var avail = p.variants.filter(function (v) { return v.available; });
    var pick = avail[0] || p.variants[0];
    if (sIdx > -1 && wantSize) avail.some(function (v) { if (String(v['option' + (sIdx + 1)] || '').toLowerCase() === wantSize) { pick = v; return true; } return false; });
    var img = upImg(p, pick);
    var opts = showOpts && p.variants.length > 1 ? p.variants.map(function (v) {
      return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (v.id === pick.id ? ' selected' : '') + '>' + escapeHtml(v.title) + '</option>';
    }).join('') : '';
    var card = document.createElement('div'); card.className = 'aov-up__card';
    card.innerHTML =
        (img ? '<a class="aov-up__img" href="' + p.url + '"><img src="' + img + '" alt="' + escapeHtml(p.title) + '" width="64" height="64" loading="lazy"></a>' : '') +
        '<div class="aov-up__info">' +
          '<a class="aov-up__name" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
          '<div class="aov-up__price"><span class="aov-up__sale" data-up-price></span> <s class="aov-up__cmp" data-up-cmp></s></div>' +
          (opts ? '<select class="aov-up__select" aria-label="Choose option">' + opts + '</select>' : '') +
        '</div>' +
        '<button type="button" class="btn btn--small aov-up__add">' + escapeHtml(btnText) + '</button>';
    var sel = card.querySelector('.aov-up__select');
    var vid = function () { return Number(sel ? sel.value : pick.id); };
    var cur = function () { return p.variants.filter(function (x) { return x.id === vid(); })[0] || pick; };
    var setPrice = function () {
      var v = cur();
      card.querySelector('[data-up-price]').textContent = money(v.price);
      var c = card.querySelector('[data-up-cmp]');
      c.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
    };
    var imgEl = card.querySelector('.aov-up__img img');
    var swapImg = function () {
      if (!imgEl) return;
      var url = upImg(p, cur()); if (!url || url === imgEl.getAttribute('src')) return;
      var pre = new Image(); var token = (imgEl.__tok = (imgEl.__tok || 0) + 1);
      imgEl.style.opacity = '0';
      pre.onload = pre.onerror = function () {
        if (token !== imgEl.__tok) return;
        setTimeout(function () { imgEl.src = url; imgEl.style.opacity = '1'; }, 120);
      };
      pre.src = url;
    };
    if (sel) sel.addEventListener('change', function () { setPrice(); swapImg(); });
    setPrice();
    var btn = card.querySelector('.aov-up__add');
    btn.addEventListener('click', function () {
      btn.classList.add('btn--loading'); btn.disabled = true;
      fetch(addUrl(), { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: vid(), quantity: 1 }] }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          btn.classList.remove('btn--loading'); btn.disabled = false;
          if (d && d.status && d.status !== 200) { btn.textContent = 'Unavailable'; return; }
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('aov:upsell-added', { detail: { product: p.id, variant: vid() } }));
        })
        .catch(function () { btn.classList.remove('btn--loading'); btn.disabled = false; });
    });
    return card;
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bundle-offer]'), initBundle);
    Array.prototype.forEach.call(document.querySelectorAll('[data-aov-upsell]'), fillUpsell);
  }
  function boot() {
    scan();
    Array.prototype.forEach.call(document.querySelectorAll('#CartDrawer [data-products], #CartPageForm [data-products]'), function (el) {
      new MutationObserver(scan).observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
